import React from "react";

import { Link } from "gatsby";

import { Icon, IconSizeEnum, IconTypeEnum } from "@/components/common/icon";
import { trimSlashes } from "@/utils/stringUtils";

import { LinkBlockItemProps } from "./types";
import "./styles.scss";

const LinkBlockItem = ({ link, urlPrefix }: LinkBlockItemProps) =>
  (
    <div className="link-block-item">
      <Link to={`/${urlPrefix}/${trimSlashes(link.data.URL)}`} key={link.data.documentId}>
        <Icon type={IconTypeEnum.Right} size={IconSizeEnum.Size24} />
        <span className="link-block-item__text">
          {link.customDisplayName ?? link.data.linkDisplayName ?? link.data.breadcrumbDisplayName}
        </span>
      </Link>
    </div>
  );

export default LinkBlockItem;
